import { useOneMailbox } from "http-hooks/mailbox/useMailbox";

const DetailSkeleton = () => (
  <div className="animate-pulse">
    <div className="h-7 bg-gray-200 rounded w-3/4 mb-8"></div>
    <div className="space-y-6">
      <div>
        <div className="h-4 bg-gray-200 rounded w-full"></div>
        <div className="h-4 bg-gray-200 rounded w-full mt-2"></div>
        <div className="h-4 bg-gray-200 rounded w-2/3 mt-2"></div>
      </div>
      <div>
        <div className="h-4 bg-gray-200 rounded w-1/4 mb-2"></div>
        <div className="h-4 bg-gray-200 rounded w-1/2"></div>
      </div>
    </div>
  </div>
);

export default function ViewMailModal({ mailId, onClose }) {
  const { data: mail, isLoading } = useOneMailbox(mailId);

  if (isLoading) {
    return <DetailSkeleton />;
  }

  if (!mail) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-500">Mail not found</p>
      </div>
    );
  }

  // Construct full PDF URL using base URL
  const baseUrl = process.env.REACT_APP_MAIN_BASE_URL || '';
  const fullPdfUrl = mail.pdfpath && mail.pdfname 
    ? `${baseUrl}${mail.pdfpath}${mail.pdfname}` 
    : null;

  return (
    <div>
      <div className="space-y-8">
        <div className="border-b border-gray-900/10 pb-8">
          <h2 className="text-base font-semibold leading-7 text-gray-900 mb-4">
            {mail.subject}
          </h2>
          
          <div className="mt-6 space-y-6">
            <div>
              <label className="block text-sm font-medium leading-6 text-gray-900 mb-2">
                Message
              </label>
              <div 
                className="text-sm text-gray-700 bg-gray-50 rounded-md p-4" 
                dangerouslySetInnerHTML={{ __html: mail.msg || "No message content" }}
              />
            </div>

            <div>
              <label className="block text-sm font-medium leading-6 text-gray-900 mb-2">
                Document
              </label>
              {fullPdfUrl ? (
                <a 
                  href={fullPdfUrl} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:text-blue-800 underline break-all text-sm"
                >
                  {mail.pdfname}
                </a>
              ) : (
                <p className="text-sm text-gray-500 italic">No document attached</p>
              )}
            </div>

            {mail.receiverCompanies && mail.receiverCompanies.length > 0 && (
              <div>
                <label className="block text-sm font-medium leading-6 text-gray-900 mb-2">
                  Receiver Companies
                </label>
                <div className="space-y-1 bg-gray-50 rounded-md p-4">
                  {mail.receiverCompanies.map((company, index) => (
                    <p key={index} className="text-sm text-gray-700">
                      {company.name} <span className="text-gray-500">({company.id})</span>
                    </p>
                  ))}
                </div>
              </div>
            )}

            <div>
              <label className="block text-sm font-medium leading-6 text-gray-900 mb-2">
                Receiver Emails
              </label>
              <p className="text-sm text-gray-700 break-words bg-gray-50 rounded-md p-4">
                {mail.receiver}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-6 flex items-center justify-end gap-x-6">
        <button
          type="button"
          className="rounded-md bg-gray-700 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-700"
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  );
}

